import { Component } from "@angular/core";

@Component({
  selector: "app-products",
  templateUrl: "./products.component.html",
  styleUrls: ["./products.component.scss"],
})
export class ProductsComponent {
  insight = [
    {
      name1: "Google ",
      name2: "Play",
      image: "assets/images/digital/edla/google-play.avif",
      details:
      "Your favorite teaching apps, now just a tap away on the Virsa Board.",
    },
    {
      name1: "Core",
      name2: " Services",
      image: "assets/images/digital/edla/core-apps-and-services.avif",
      details:
      "Start teaching right away—Google’s core services are built into every Virsa board.",
    },
    {
      name1: "Collaboration ",
      name2: " Tools",
      image: "assets/images/digital/edla/collaboration-tools.avif",
      details:
        "Easily access and edit your lesson materials right from the board with Google Docs Editors.",
    },
  ];
}
